import React from "react";

function ProductDetails({ data }) {
  return (
    <div>
      {data && (
        <div>
          <table class="table table-bordered">
            <thead>
              <tr>
                <th scope="col">Code</th>
                <th scope="col">BU</th>
                <th scope="col">Description</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{data.itemCode || ""}</td>
                <td>{data.bu || ""}</td>
                <td>{data.description || ""}</td>
              </tr>
            </tbody>
          </table>
          <br />
          <h5>Additional Details</h5>
          <hr />
          <div className="row">
            <div className="col">
              <table class="table table.sm table-bordered">
                <thead>
                  <tr>
                    <th scope="col">#</th>
                    <th scope="col">Quantity</th>
                    <th scope="col">Net</th>
                    <th scope="col">Blank</th>
                  </tr>
                </thead>
                <tbody>
                  {[...Array(12).keys()].map((i) => {
                    const num = i + 1;
                    return (
                      <tr>
                        <td>{num}</td>
                        <td>{data["qty" + num] || ""}</td>
                        <td>{data["net" + num] || ""}</td>
                        <td>{data["blank" + num] || ""}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default ProductDetails;
